// Goshna.jsx
import React, { useState } from 'react';
import { Container, Row, Col, Card, Button, ProgressBar } from 'react-bootstrap';

export const Goshna = () => {
  const [activePledge, setActivePledge] = useState(null);

  const styles = {
    pageHeader: {
      background: 'linear-gradient(135deg, var(--saffron-deep) 0%, var(--saffron-dark) 100%)',
      padding: '60px 0 40px',
      marginTop: '75px',
      color: 'var(--white-pure)',
      textAlign: 'center'
    },
    sectionTitle: {
      fontSize: '2.5rem',
      fontWeight: 700,
      color: '#1e1e1e',
      marginBottom: '1rem',
      position: 'relative',
      display: 'inline-block'
    },
    titleUnderline: {
      width: '80px',
      height: '4px',
      backgroundColor: 'var(--saffron-deep)',
      margin: '1rem 0 2rem',
      borderRadius: '2px'
    },
    pledgeCard: {
      backgroundColor: 'var(--white-pure)',
      border: '1px solid var(--saffron-light)',
      borderRadius: '20px',
      padding: '2rem',
      boxShadow: '0 10px 30px -10px rgba(229, 123, 28, 0.1)',
      transition: 'all 0.3s ease',
      height: '100%',
      cursor: 'pointer'
    },
    activePledgeCard: {
      border: '3px solid var(--saffron-deep)',
      transform: 'translateY(-10px)',
      boxShadow: '0 20px 40px -10px rgba(229, 123, 28, 0.3)'
    },
    visionCard: {
      backgroundColor: 'var(--saffron-soft)',
      border: '2px dashed var(--saffron-deep)',
      borderRadius: '20px',
      padding: '2rem',
      height: '100%'
    },
    progressBar: {
      height: '10px',
      backgroundColor: 'var(--saffron-light)',
      borderRadius: '5px'
    },
    progressFill: {
      backgroundColor: 'var(--saffron-deep)',
      borderRadius: '5px'
    }
  };

  // Main Pledges
  const mainPledges = [
    {
      id: 1,
      title: "स्वतंत्रता सेनानियों के सपनों का भारत",
      icon: "fa-flag-india",
      category: "राष्ट्रभक्ति",
      description: "हमारे स्वतंत्रता सेनानियों ने जिस भारत का सपना देखा था, उसके निर्माण का संकल्प। विकसित मोहम्मदी का निर्माण हमारा लक्ष्य।",
      fullDescription: "पंडित भगवान दीन शर्मा जी सहित अमर स्वतंत्रता सेनानियों के सपनों का भारत बनाना हमारा प्रथम संकल्प है। एक ऐसा भारत जहाँ हर नागरिक को समान अधिकार, सम्मान और विकास के अवसर मिलें। मोहम्मदी विधानसभा क्षेत्र को विकास का आदर्श केंद्र बनाएंगे।",
      actionPoints: [
        "स्वतंत्रता सेनानियों के परिवारों के लिए विशेष पेंशन योजना",
        "शहीद स्मारक का निर्माण और उनकी गाथाओं का संरक्षण",
        "युवाओं को देशभक्ति से जोड़ने के लिए कार्यक्रम"
      ],
      progress: 75,
      timeline: "2025-2027"
    },
    {
      id: 2,
      title: "युवाओं में राष्ट्रभक्ति और स्वरोजगार",
      icon: "fa-users",
      category: "युवा सशक्तिकरण",
      description: "युवाओं में राष्ट्रभक्ति, संस्कार और स्वरोजगार को बढ़ावा। हर युवा को रोजगार और देशभक्ति की शिक्षा देने का वादा।",
      fullDescription: "हमारे युवा देश का भविष्य हैं। उन्हें राष्ट्रभक्ति के संस्कार देने के साथ-साथ स्वरोजगार के अवसर प्रदान करना हमारा लक्ष्य है। कौशल विकास केंद्रों के माध्यम से युवाओं को आत्मनिर्भर बनाएंगे।",
      actionPoints: [
        "हर ब्लॉक में युवा कौशल विकास केंद्र",
        "स्टार्टअप के लिए 1 लाख रु. तक का अनुदान",
        "राष्ट्रभक्ति पाठ्यक्रम का समावेश"
      ],
      progress: 60,
      timeline: "2025-2027"
    },
    {
      id: 3,
      title: "शिक्षा, स्वास्थ्य और कृषि में क्रांति",
      icon: "fa-graduation-cap",
      category: "बुनियादी विकास",
      description: "शिक्षा, स्वास्थ्य और कृषि के क्षेत्र में ऐतिहासिक और आधुनिक सुधार। हर गाँव में स्कूल, अस्पताल और किसानों के लिए आधुनिक सुविधाएं।",
      fullDescription: "शिक्षा, स्वास्थ्य और कृषि तीन ऐसे क्षेत्र हैं जिनके विकास से पूरा समाज विकसित होता है। हर गाँव में गुणवत्तापूर्ण शिक्षा, स्वास्थ्य सुविधाएं और किसानों के लिए आधुनिक तकनीक उपलब्ध कराना हमारा संकल्प है।",
      actionPoints: [
        "हर गाँव में डिजिटल लाइब्रेरी और स्मार्ट क्लास",
        "प्राथमिक स्वास्थ्य केंद्रों का उन्नयन",
        "किसानों के लिए मृदा परीक्षण और उन्नत बीज"
      ],
      progress: 50,
      timeline: "2025-2027"
    },
    {
      id: 4,
      title: "महिला सुरक्षा और सशक्तिकरण",
      icon: "fa-female",
      category: "महिला कल्याण",
      description: "महिलाओं के लिए सुरक्षा और स्वरोजगार के अवसर। महिला हेल्पलाइन और स्वयं सहायता समूहों का सशक्तिकरण।",
      fullDescription: "महिलाओं की सुरक्षा और उनका आर्थिक सशक्तिकरण हमारी प्राथमिकता है। हर गाँव में महिला हेल्पलाइन और स्वयं सहायता समूहों के माध्यम से महिलाओं को आत्मनिर्भर बनाएंगे।",
      actionPoints: [
        "महिला हेल्पलाइन नंबर 24/7 सुविधा",
        "स्वयं सहायता समूहों को 5 लाख रु. तक ऋण",
        "महिला पुलिस चौकियों की स्थापना"
      ],
      progress: 40,
      timeline: "2025-2027"
    },
    {
      id: 5,
      title: "गौ-संरक्षण और संवर्धन",
      icon: "fa-cow",
      category: "गौ-सेवा",
      description: "गौशालाओं का विकास और गौ-उत्पादों को बढ़ावा। गौ-आधारित कृषि और गौ-संरक्षण केंद्र।",
      fullDescription: "गौ-संरक्षण केवल धार्मिक नहीं, आर्थिक दृष्टि से भी आवश्यक है। गौ-आधारित कृषि, गौ-उत्पादों का प्रचार-प्रसार और निराश्रित गौवंश के संरक्षण के लिए ठोस कदम उठाएंगे।",
      actionPoints: [
        "हर ब्लॉक में आधुनिक गौशाला",
        "गौ-उत्पादों के लिए बाजार उपलब्ध कराना",
        "निराश्रित गौवंश के लिए चारा योजना"
      ],
      progress: 35,
      timeline: "2025-2027"
    },
    {
      id: 6,
      title: "सनातन धर्म और संस्कृति का संरक्षण",
      icon: "fa-pray",
      category: "धार्मिक गौरव",
      description: "सनातन धर्म की रक्षा, मंदिरों का जीर्णोद्धार और धार्मिक स्थलों का विकास।",
      fullDescription: "सनातन धर्म हमारी पहचान है। धार्मिक स्थलों के जीर्णोद्धार, धार्मिक शिक्षा के प्रचार-प्रसार और सनातन संस्कृति के संरक्षण के लिए हरसंभव प्रयास करेंगे।",
      actionPoints: [
        "50+ धार्मिक स्थलों का जीर्णोद्धार",
        "धार्मिक शिक्षा के लिए संस्कृत पाठशालाएं",
        "धार्मिक पर्वों पर सरकारी सहयोग"
      ],
      progress: 80,
      timeline: "2025-2027"
    }
  ];

  // Sector-wise Pledges
  const sectorPledges = [
    {
      sector: "कृषि एवं किसान कल्याण",
      icon: "fa-tractor",
      points: [
        "किसानों को उन्नत बीज और उर्वरक समय पर उपलब्ध कराना",
        "नहरों की सफाई और सिंचाई सुविधाओं का विस्तार",
        "फसल बीमा योजना का शत-प्रतिशत लाभ",
        "कृषि उपज के लिए न्यूनतम समर्थन मूल्य की गारंटी",
        "किसान क्रेडिट कार्ड की प्रक्रिया सरल बनाना"
      ]
    },
    {
      sector: "शिक्षा एवं युवा विकास",
      icon: "fa-book-open",
      points: [
        "सरकारी स्कूलों में स्मार्ट क्लास की सुविधा",
        "मेधावी छात्रों के लिए छात्रवृत्ति योजना",
        "प्रतियोगी परीक्षाओं की निःशुल्क कोचिंग",
        "युवाओं के लिए कौशल विकास केंद्र",
        "खेल सुविधाओं का विकास"
      ]
    },
    {
      sector: "स्वास्थ्य एवं परिवार कल्याण",
      icon: "fa-hospital",
      points: [
        "हर गाँव में आशा कार्यकर्ताओं की नियुक्ति",
        "प्राथमिक स्वास्थ्य केंद्रों को 24/7 सुविधा",
        "गर्भवती महिलाओं के लिए विशेष योजना",
        "बुजुर्गों के लिए निःशुल्क स्वास्थ्य जांच",
        "एम्बुलेंस सेवा का विस्तार"
      ]
    },
    {
      sector: "बुनियादी ढाँचा एवं विकास",
      icon: "fa-road",
      points: [
        "हर गाँव तक पक्की सड़क का निर्माण",
        "स्ट्रीट लाइट और सौर ऊर्जा को बढ़ावा",
        "हर घर तक पेयजल की सुविधा",
        "सार्वजनिक शौचालयों का निर्माण",
        "खराब सड़कों की मरम्मत"
      ]
    },
    {
      sector: "महिला एवं बाल विकास",
      icon: "fa-child",
      points: [
        "महिला हेल्पलाइन की स्थापना",
        "बालिकाओं की शिक्षा के लिए प्रोत्साहन योजना",
        "महिला स्वयं सहायता समूहों को बढ़ावा",
        "कन्या विवाह योजना में वृद्धि",
        "बाल श्रम पर पूर्ण प्रतिबंध"
      ]
    },
    {
      sector: "ग्रामीण विकास",
      icon: "fa-home",
      points: [
        "हर गाँव में सामुदायिक भवन",
        "ग्राम सड़कों का चौड़ीकरण",
        "नाली निर्माण एवं सफाई व्यवस्था",
        "ग्रामीण रोजगार गारंटी योजना का सुदृढ़ीकरण",
        "ग्राम पंचायतों को अधिकार"
      ]
    }
  ];

  // Pledge Statistics
  const pledgeStats = [
    { label: "कुल संकल्प", value: 24, icon: "fa-file-signature" },
    { label: "पूर्ण किए गए", value: 8, icon: "fa-check-circle", color: "success" },
    { label: "प्रगति पर", value: 12, icon: "fa-spinner", color: "warning" },
    { label: "शेष", value: 4, icon: "fa-clock", color: "danger" }
  ];

  // Five Year Plan
  const fiveYearPlan = [
    {
      year: "वर्ष 1 (2025)",
      focus: "बुनियादी ढाँचे का विकास",
      targets: [
        "सड़क निर्माण - 50 गाँव",
        "स्ट्रीट लाइट - 100 गाँव",
        "स्कूलों का जीर्णोद्धार - 20 स्कूल"
      ]
    },
    {
      year: "वर्ष 2 (2026)",
      focus: "शिक्षा एवं स्वास्थ्य",
      targets: [
        "स्मार्ट क्लास - 50 स्कूल",
        "स्वास्थ्य केंद्र - 10 नए",
        "छात्रवृत्ति - 1000 छात्र"
      ]
    },
    {
      year: "वर्ष 3 (2027)",
      focus: "कृषि एवं ग्रामीण विकास",
      targets: [
        "सिंचाई सुविधा - 500 हेक्टेयर",
        "गौशाला - 5 नई",
        "किसान क्रेडिट कार्ड - 5000 किसान"
      ]
    }
  ];

  return (
    <>
      {/* Page Header */}
      <section style={styles.pageHeader}>
        <Container>
          <h1 className="display-3 fw-bold" style={{ color: 'var(--white-pure)' }}>
            <i className="fas fa-file-signature me-3"></i>
            घोषणापत्र
          </h1>
          <p className="fs-4" style={{ color: 'var(--saffron-light)' }}>
            "हमारा संकल्प, आपका विश्वास" — पंडित धीरेंद्र कुमार शर्मा
          </p>
        </Container>
      </section>

      {/* Introduction */}
      <section className="py-5">
        <Container>
          <Row className="justify-content-center">
            <Col lg={10}>
              <Card className="border-0 shadow-sm" style={{ backgroundColor: 'var(--saffron-soft)' }}>
                <Card.Body className="p-5 text-center">
                  <i className="fas fa-quote-left fa-3x mb-3" style={{ color: 'var(--saffron-deep)' }}></i>
                  <h2 className="fs-1 fw-bold mb-4" style={{ color: 'var(--saffron-dark)' }}>
                    आपका विश्वास, हमारा संकल्प
                  </h2>
                  <p className="fs-5" style={{ lineHeight: 1.8 }}>
                    पंडित धीरेंद्र कुमार शर्मा का घोषणापत्र केवल वादों का संग्रह नहीं, 
                    बल्कि 144 मोहम्मदी विधानसभा क्षेत्र के विकास का एक ठोस रोडमैप है। 
                    स्वतंत्रता सेनानियों की विरासत को आगे बढ़ाते हुए, हम क्षेत्र के हर गाँव, 
                    हर मोहल्ले और हर परिवार तक विकास पहुँचाने के लिए संकल्पित हैं।
                  </p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Pledge Statistics */}
      <section className="py-5" style={{ backgroundColor: 'var(--white-off)' }}>
        <Container>
          <h2 className="section-title text-center" style={styles.sectionTitle}>
            <i className="fas fa-chart-pie me-2" style={{ color: 'var(--saffron-deep)' }}></i>
            संकल्पों की स्थिति
          </h2>
          <div className="title-underline mx-auto mb-5" style={{ width: '80px', height: '4px', backgroundColor: 'var(--saffron-deep)' }}></div>

          <Row className="g-4">
            {pledgeStats.map((stat, index) => (
              <Col md={3} key={index}>
                <Card className="border-0 shadow-sm text-center h-100">
                  <Card.Body className="p-4">
                    <div className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3"
                         style={{ width: '80px', height: '80px', backgroundColor: 'var(--saffron-soft)', border: '3px solid var(--saffron-deep)' }}>
                      <i className={`fas ${stat.icon} fa-2x`} style={{ color: 'var(--saffron-deep)' }}></i>
                    </div>
                    <h3 style={{ color: 'var(--saffron-dark)', fontSize: '2.5rem' }}>{stat.value}</h3>
                    <p className="fs-5 mb-0">{stat.label}</p>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Main Pledges */}
      <section className="py-5">
        <Container>
          <h2 className="section-title text-center" style={styles.sectionTitle}>
            <i className="fas fa-hand-paper me-2" style={{ color: 'var(--saffron-deep)' }}></i>
            हमारे मुख्य संकल्प
          </h2>
          <div className="title-underline mx-auto mb-5" style={{ width: '80px', height: '4px', backgroundColor: 'var(--saffron-deep)' }}></div>

          <Row className="g-4">
            {mainPledges.map((pledge) => (
              <Col lg={4} md={6} key={pledge.id}>
                <div
                  style={{
                    ...styles.pledgeCard,
                    ...(activePledge === pledge.id ? styles.activePledgeCard : {})
                  }}
                  onMouseEnter={() => setActivePledge(pledge.id)}
                  onMouseLeave={() => setActivePledge(null)}
                >
                  <div className="d-flex align-items-center gap-3 mb-3">
                    <div className="rounded-circle d-flex align-items-center justify-content-center"
                         style={{ width: '60px', height: '60px', backgroundColor: 'var(--saffron-soft)', border: '2px solid var(--saffron-deep)' }}>
                      <i className={`fas ${pledge.icon} fa-2x`} style={{ color: 'var(--saffron-deep)' }}></i>
                    </div>
                    <div>
                      <span className="badge mb-1" style={{ backgroundColor: 'var(--saffron-soft)', color: 'var(--saffron-dark)' }}>
                        {pledge.category}
                      </span>
                      <h4 style={{ color: 'var(--saffron-dark)', fontSize: '1.3rem' }}>{pledge.title}</h4>
                    </div>
                  </div>

                  <p style={{ color: '#4f4f4f' }}>{pledge.description}</p>

                  {activePledge === pledge.id && (
                    <div className="mt-3">
                      <p className="fw-bold mb-2" style={{ color: 'var(--saffron-dark)' }}>प्रमुख कार्य:</p>
                      <ul className="list-unstyled">
                        {pledge.actionPoints.map((point, idx) => (
                          <li key={idx} className="mb-1">
                            <i className="fas fa-check-circle me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                            {point}
                          </li>
                        ))}
                      </ul>
                      
                      <div className="mt-3">
                        <div className="d-flex justify-content-between mb-1">
                          <span>प्रगति</span>
                          <span>{pledge.progress}%</span>
                        </div>
                        <div style={styles.progressBar}>
                          <div style={{ ...styles.progressFill, width: `${pledge.progress}%`, height: '10px' }}></div>
                        </div>
                        <p className="text-muted small mt-2">समयसीमा: {pledge.timeline}</p>
                      </div>
                    </div>
                  )}
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Sector-wise Pledges */}
      <section className="py-5" style={{ backgroundColor: 'var(--white-off)' }}>
        <Container>
          <h2 className="section-title text-center" style={styles.sectionTitle}>
            <i className="fas fa-building me-2" style={{ color: 'var(--saffron-deep)' }}></i>
            क्षेत्रवार संकल्प
          </h2>
          <div className="title-underline mx-auto mb-5" style={{ width: '80px', height: '4px', backgroundColor: 'var(--saffron-deep)' }}></div>

          <Row className="g-4">
            {sectorPledges.map((sector, index) => (
              <Col md={6} lg={4} key={index}>
                <Card className="border-0 shadow-sm h-100">
                  <Card.Header className="py-3" style={{ backgroundColor: 'var(--saffron-deep)', color: 'white', borderTopLeftRadius: '15px', borderTopRightRadius: '15px' }}>
                    <h5 className="mb-0">
                      <i className={`fas ${sector.icon} me-2`}></i>
                      {sector.sector}
                    </h5>
                  </Card.Header>
                  <Card.Body className="p-4">
                    <ul className="list-unstyled">
                      {sector.points.map((point, idx) => (
                        <li key={idx} className="mb-2 d-flex align-items-start gap-2">
                          <i className="fas fa-check-circle mt-1" style={{ color: 'var(--saffron-deep)' }}></i>
                          <span>{point}</span>
                        </li>
                      ))}
                    </ul>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Five Year Plan */}
      <section className="py-5">
        <Container>
          <h2 className="section-title text-center" style={styles.sectionTitle}>
            <i className="fas fa-calendar-alt me-2" style={{ color: 'var(--saffron-deep)' }}></i>
            पंचवर्षीय योजना (2025-2027)
          </h2>
          <div className="title-underline mx-auto mb-5" style={{ width: '80px', height: '4px', backgroundColor: 'var(--saffron-deep)' }}></div>

          <Row className="g-4">
            {fiveYearPlan.map((plan, index) => (
              <Col md={4} key={index}>
                <div style={styles.visionCard}>
                  <div className="text-center mb-3">
                    <span className="badge p-2" style={{ backgroundColor: 'var(--saffron-deep)', color: 'white', fontSize: '1rem' }}>
                      {plan.year}
                    </span>
                  </div>
                  <h4 className="text-center mb-3" style={{ color: 'var(--saffron-dark)' }}>{plan.focus}</h4>
                  <ul className="list-unstyled">
                    {plan.targets.map((target, idx) => (
                      <li key={idx} className="mb-2">
                        <i className="fas fa-bullseye me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                        {target}
                      </li>
                    ))}
                  </ul>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Vision for 2027 */}
      <section className="py-5" style={{ backgroundColor: 'var(--saffron-soft)' }}>
        <Container>
          <Row className="align-items-center g-4">
            <Col lg={6}>
              <h2 className="display-5 fw-bold mb-4" style={{ color: 'var(--saffron-dark)' }}>
                2027 का विजन
              </h2>
              <p className="fs-5 mb-4" style={{ lineHeight: 1.8 }}>
                वर्ष 2027 तक 144 मोहम्मदी विधानसभा क्षेत्र को उत्तर प्रदेश का 
                <strong style={{ color: 'var(--saffron-deep)' }}> सबसे विकसित विधानसभा क्षेत्र</strong> बनाना हमारा लक्ष्य है।
              </p>
              <div className="d-flex gap-3 flex-wrap">
                <div className="text-center p-3 bg-white rounded-3" style={{ minWidth: '120px' }}>
                  <i className="fas fa-road fa-2x mb-2" style={{ color: 'var(--saffron-deep)' }}></i>
                  <h4 className="mb-0">100%</h4>
                  <p className="small mb-0">पक्की सड़कें</p>
                </div>
                <div className="text-center p-3 bg-white rounded-3" style={{ minWidth: '120px' }}>
                  <i className="fas fa-school fa-2x mb-2" style={{ color: 'var(--saffron-deep)' }}></i>
                  <h4 className="mb-0">100%</h4>
                  <p className="small mb-0">साक्षरता दर</p>
                </div>
                <div className="text-center p-3 bg-white rounded-3" style={{ minWidth: '120px' }}>
                  <i className="fas fa-lightbulb fa-2x mb-2" style={{ color: 'var(--saffron-deep)' }}></i>
                  <h4 className="mb-0">100%</h4>
                  <p className="small mb-0">बिजली कनेक्शन</p>
                </div>
              </div>
            </Col>
            <Col lg={6}>
              <div className="rounded-4 d-flex align-items-center justify-content-center"
                   style={{ width: '100%', height: '350px', backgroundColor: 'var(--white-pure)', border: '4px solid var(--saffron-deep)', borderRadius: '20px' }}>
                {/* <i className="fas fa-flag-checkered fa-5x" style={{ color: 'var(--saffron-deep)' }}></i> */}
                <img src="misss.png" alt="विजन 2027" className="img-fluid rounded-4" style={{ width: '100%', height: '100%', }} /> 
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Download Pledge */}
      <section className="py-5 text-center">
        <Container>
          <Card className="border-0 shadow-sm" style={{ backgroundColor: 'var(--white-off)' }}>
            <Card.Body className="p-5">
              <i className="fas fa-file-pdf fa-4x mb-3" style={{ color: 'var(--saffron-deep)' }}></i>
              <h2 className="fs-1 fw-bold mb-3" style={{ color: 'var(--saffron-dark)' }}>
                पूरा घोषणापत्र डाउनलोड करें
              </h2>
              <p className="fs-5 mb-4">
                घोषणापत्र की पूरी PDF डाउनलोड करें और हमारे संकल्पों को विस्तार से जानें।
              </p>
              <Button
                className="px-5 py-3 rounded-pill fw-bold border-0"
                style={{ backgroundColor: 'var(--saffron-deep)', color: 'white', fontSize: '1.2rem' }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.color = 'var(--saffron-deep)';
                  e.target.style.border = '2px solid var(--saffron-deep)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'var(--saffron-deep)';
                  e.target.style.color = 'white';
                  e.target.style.border = 'none';
                }}
              >
                <i className="fas fa-download me-2"></i>
                डाउनलोड करें (PDF)
              </Button>
            </Card.Body>
          </Card>
        </Container>
      </section>

      {/* Support Pledge */}
      <section className="py-5 text-center" style={{ backgroundColor: 'var(--saffron-soft)' }}>
        <Container>
          <i className="fas fa-hand-paper fa-4x mb-3" style={{ color: 'var(--saffron-deep)' }}></i>
          <h2 className="display-5 fw-bold mb-3" style={{ color: 'var(--saffron-dark)' }}>
            संकल्प को समर्थन दें
          </h2>
          <p className="fs-5 mb-4">
            हमारे घोषणापत्र से सहमत हैं? अपना समर्थन दर्ज करें और बदलाव का हिस्सा बनें।
          </p>
          <Button
            href="/contact"
            className="px-5 py-3 rounded-pill fw-bold border-0 me-3"
            style={{ backgroundColor: 'var(--saffron-deep)', color: 'white', fontSize: '1.2rem' }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.color = 'var(--saffron-deep)';
              e.target.style.border = '2px solid var(--saffron-deep)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'var(--saffron-deep)';
              e.target.style.color = 'white';
              e.target.style.border = 'none';
            }}
          >
            <i className="fas fa-thumbs-up me-2"></i>
            समर्थन करें
          </Button>
          <Button
            href="/janta-darbar"
            className="px-5 py-3 rounded-pill fw-bold border-0"
            style={{ backgroundColor: 'transparent', color: 'var(--saffron-deep)', border: '2px solid var(--saffron-deep)', fontSize: '1.2rem' }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = 'var(--saffron-deep)';
              e.target.style.color = 'white';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.color = 'var(--saffron-deep)';
            }}
          >
            <i className="fas fa-users me-2"></i>
            जनता दरबार में आएं
          </Button>
        </Container>
      </section>
    </>
  );
};

export default Goshna;